import React from 'react'
import { Grid } from '@material-ui/core'
import styles from './app_info_header.module.css'
import AppInfoHeaderChild from './app_info_header_child'
import strings from '../../../strings/strings.json'
import ProgramLanguage from '../../../modules/program_langueage/program_langueage'
import VolCalculator from '../../../modules/vol_calculator/vol_calculator'
import AppMaker from '../../../modules/app_maker/app_maker'

export default function AppInfoHeader(props) {
    const info = props.info

    const checkNull = (data) => {
        return data ? data : "-"
    }

    return (
        <div className={styles.container}>
            <Grid container>
                <Grid item xs={12} md={1}>
                    <AppInfoHeaderChild
                        css={styles.child_container_left_border}
                        title={strings.fileDetail_fileType}
                        subTitle={info.FileType}
                    />
                </Grid>
                <Grid item xs={12} md={1}>
                    <AppInfoHeaderChild
                        css={styles.child_container_left_border}
                        title={strings.fileDetail_version}
                        subTitle={checkNull(info.DisplayVersion)}
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <AppInfoHeaderChild
                        css={styles.child_container_left_border}
                        title={strings.fileDetail_versionCode}
                        subTitle={checkNull(info.VersionCode)}
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <AppInfoHeaderChild
                        css={styles.child_container_left_border}
                        title={strings.fileDetail_appSize}
                        subTitle={VolCalculator.calculate(info.FileSize)}
                    />
                </Grid>
                <Grid item xs={12} md={1}>
                    <AppInfoHeaderChild
                        css={styles.child_container_left_border}
                        title={strings.fileDetail_minSDK}
                        subTitle={info.MinSDK}
                    />
                </Grid>
                <Grid item xs={12} md={1}>
                    <AppInfoHeaderChild
                        css={styles.child_container_left_border}
                        title={strings.fileDetail_TargetSDK}
                        subTitle={info.TargetSDK}
                    />
                </Grid>
               <Grid item xs={12} md={2}>
                    <AppInfoHeaderChild
                        css={styles.child_container_left_border}
                        title={strings.fileDetail_langType}
                        subTitle={<ProgramLanguage md5={props.data.md5} info={info} isVulns={props.isVulns} />}
                    />
                </Grid>
                 <Grid item xs={12} md={2}>
                    <AppInfoHeaderChild
                        title={strings.fileDetail_appMaker}
                        subTitle={<AppMaker md5={props.data.md5} info={info} />}
                    />
                </Grid>
            </Grid>
        </div>

    )
}